const TXT_EMAIL_DATA = {
    THIS: 'txtEmailData',
    MENSAGEM_ERRO: 'mensagemErro'
};

export default TXT_EMAIL_DATA;
